import destIcon from "@icons/destination.svg";
import useContent from "@lib/use_content";
import { GoogleMap, Marker } from "@react-google-maps/api";
import PulseLoader from "@hudson/ui/components/Loader/PulseLoader";
import Button from "@hudson/ui/components/FormFields/Button";

export default function Location({
  loc,
  onRemove,
  submitting,
}: {
  loc: be.Location;
  onRemove: (id: number) => void;
  submitting?: boolean;
}): JSX.Element {
  const { data, loading, error } = useContent(["beProfileLocationsRemoveButton"]);

  return (
    <>
      <div className={`flex flex-col w-full justify-between relative truncate`}>
        <div
          className={`flex-1 truncate pt-4 px-4 ${loc.latLng ? "absolute bg-white/60 z-50 rounded-tl-md pb-5 backdrop-blur-lg" : "pb-3 bg-white"}`}
          style={{
            "--mask": `linear-gradient(to top, 
      rgba(0,0,0, 0) 0,  rgba(0,0,0, 1) 10%, rgba(0,0,0, 1) 0
  ) 100% 50% / 100% 100% repeat-x`,
            "-webkit-mask": "var(--mask)",
            mask: "var(--mask)",
          }}
        >
          <div className="flex items-center space-x-3">
            <h3 className="truncate text-lg font-semibold text-[--primary-color]">
              {loc.displayName}
            </h3>
          </div>
          <p className="mt-0.5 truncate text-sm text-gray-500">{loc.displayAddress}</p>
        </div>

        {loc.latLng && (
          <div className="rounded-t-md overflow-hidden relative">
            <GoogleMap
              mapContainerStyle={{ width: "100%", height: "10rem" }}
              center={loc.latLng}
              onLoad={(map) => {
                map.setCenter(loc.latLng);
                map.setZoom(14);
              }}
              options={{
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
              }}
            >
              <Marker
                position={loc.latLng}
                icon={{ scaledSize: new google.maps.Size(35, 35), url: destIcon.src }}
              />
            </GoogleMap>
          </div>
        )}
      </div>
      <div>
        <div className="-mt-px flex divide-x divide-gray-200">
          <div className="flex w-0 flex-1">
            <Button
              disabled={submitting}
              className="rounded-t-none relative -mr-px cursor-pointer inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900"
              onClick={() => onRemove(Number(loc.id))}
            >
              {submitting ? (
                <PulseLoader colorVar="primary-color" size={1.5} />
              ) : (
                <div className="flex gap-x-3 items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="h-5 w-5 text-gray-400"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    />
                  </svg>
                  <div>{data?.content.beProfileLocationsRemoveButton}</div>
                </div>
              )}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
